export default __webpack_public_path__ + "static/media/cards-brands.d237d68d.png";